// API Configuration
// This file contains the base URL for all API requests

// Development environment
// const API_BASE_URL = 'http://localhost:8000/'; // http://192.168.1.3:8000

// Production environment (uncomment when deploying)
const API_BASE_URL = 'https://api.haseela.online';

// Export the API base URL
export const apiBaseUrl = API_BASE_URL;


// API timeout configuration (in milliseconds)
export const API_TIMEOUT = 30000;

// Default headers
export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
};

// Official website contact
export const WHATSAPP_NUMBER = '972593808022';
export const CONTACT_EMAIL = 'youseftareq33@gmail.com';

const config = {
    apiBaseUrl,
    API_TIMEOUT,
    DEFAULT_HEADERS,
    WHATSAPP_NUMBER,
    CONTACT_EMAIL,
};

export default config;
